<template>
  <div>
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="标题">
        <el-input v-model="form.coopers.title" class="coopertitle"></el-input>
      </el-form-item>
      <el-form-item label="简介">
        <el-input type="textarea" v-model="form.coopers.intro"></el-input>
      </el-form-item>
      <el-form-item label="合作伙伴">
        <div class="cooperup">
          <el-upload
            class="upload-demo"
            action="https://jsonplaceholder.typicode.com/posts/"
            :on-success="coopers()"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
          <div>
            <img src="http://res.sjzqcrl.com/1.png" alt="全城热练" />
          </div>
        </div>
        <div v-for="item in form.coopers.content" :key="item.id" class="coopers">
          <img :src="item.img" :alt="item.title" />
          <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="dete(item)"></el-button>
        </div>
      </el-form-item>
      <el-form-item>
      <el-button type="primary" @click="onSubmit">确认修改</el-button>
      <el-button @click="goback">返回</el-button>
    </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        coopers: {
          title: "我们的合作用户",
          intro: "",
          content: [
            { id: 1, img: "http://res.sjzqcrl.com/1.png" },
            { id: 2, img: "http://res.sjzqcrl.com/1.png" },
            { id: 3, img: "http://res.sjzqcrl.com/1.png" },
            { id: 4, img: "http://res.sjzqcrl.com/1.png" },
            { id: 5, img: "http://res.sjzqcrl.com/1.png" },
            { id: 6, img: "http://res.sjzqcrl.com/1.png" },
            { id: 7, img: "http://res.sjzqcrl.com/1.png" },
            { id: 8, img: "http://res.sjzqcrl.com/1.png" },
            { id: 9, img: "http://res.sjzqcrl.com/1.png" },
            { id: 10, img: "http://res.sjzqcrl.com/1.png" },
            { id: 11, img: "http://res.sjzqcrl.com/1.png" },
            { id: 12, img: "http://res.sjzqcrl.com/1.png" },
            { id: 13, img: "http://res.sjzqcrl.com/1.png" },
            { id: 14, img: "http://res.sjzqcrl.com/1.png" },
            { id: 15, img: "http://res.sjzqcrl.com/1.png" },
            { id: 16, img: "http://res.sjzqcrl.com/1.png" },
            { id: 17, img: "http://res.sjzqcrl.com/1.png" },
            { id: 18, img: "http://res.sjzqcrl.com/1.png" },
            { id: 19, img: "http://res.sjzqcrl.com/1.png" },
            { id: 20, img: "http://res.sjzqcrl.com/1.png" },
            { id: 21, img: "http://res.sjzqcrl.com/1.png" },
            { id: 22, img: "http://res.sjzqcrl.com/1.png" },
            { id: 23, img: "http://res.sjzqcrl.com/1.png" }
          ]
        }
      }
    };
  },
  methods: {
    coopers() {},
    dete(val) {
      this.form.coopers.content.splice(
        this.form.coopers.content.indexOf(val),
        1
      );
    },
    onSubmit() {},
    goback() {
      this.$router.push("/admin/index/onepage");
    }
  }
};
</script>

<style lang="less" scoped>
.coopertitle {
  width: 30%;
  margin-bottom: 20px;
}
.cooperup {
  margin-bottom: 20px;
}
.coopers {
  display: inline-block;
  width: 15%;
  margin: 15px;
  img {
    width: 150px;
  }
}
.el-upload {
  margin-bottom: 20px;
}
.el-button {
  margin-left: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/onepage/index.vue